import { FC } from 'react';
import { IStatusItemProps } from './types';
import InteractiveButton from '../../components/InteractiveButton/InteractiveButton';
import { ButtonType } from '../../types/button-type';
import classNames from 'classnames';

const StatusListItem: FC<IStatusItemProps> = (props) => {
  const { item, cycleStatus, onClick } = props;

  const buttonType = item.value === cycleStatus ? ButtonType.Primary : ButtonType.PrimaryInverseWhite;

  const className = classNames('w-full', 'uppercase')

  return (
    <InteractiveButton className={className} onClick={onClick} type={buttonType}>
      {item.text}
    </InteractiveButton>
  )
}

export default StatusListItem;